import { socialNetworks } from "../../constants/index";

type Variant = "footer" | "hero";

type SocialLink = {
  name: string;
  url: string;
  icon: React.ElementType;
};

export const ButtonSocialNetworks = ({
  variant = "footer",
}: {
  variant?: Variant;
}) => {
  const styles = {
    footer: {
      button: "btn-social-footer",
      icon: "icon-social-footer",
    },
    hero: {
      button: "btn-social-header",
      icon: "icon-social-header",
    },
  };

  const { button, icon } = styles[variant] || styles.footer;

  return (
    <div className="flex flex-wrap justify-center">
      {/* <div className="flex flex-wrap justify-center gap-2 xs:gan-1 sm:gap-4"> */}
      {socialNetworks.map((link: SocialLink) => {
        const Icon = link.icon;

        return (
          <a
            key={link.name}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={link.name}
            className={button}
          >
            <Icon className={icon} />
          </a>
        );
      })}
    </div>
  );
};
